// eslint-disable-next-line import/prefer-default-export
export const subscribePromoPages = [
  {
    id: 'brookerfilms',
    name: 'Brooker Films',
    videoUrl: 'https://www.youtube.com/watch?v=H1fAMTYExKk',
    // planId: 'SUB-5206',
    // currencyCode: 'USD',
    couponCode: 'BROOKERFILMS23',
  },
  {
    id: 'justin-serran',
    name: 'Justin Serran',
    videoUrl: 'https://youtu.be/UP7FP5MosRY',
    // planId: 'SUB-5206',
    // currencyCode: 'USD',
    couponCode: 'JUSTINSERRAN23',
  },
];
